import { Input as AntInput } from "antd";
import { useEffect } from "react";
import { useRef } from "react";

/**
 * Wrapper component for Ant Design Input
 *
 * This wrapper allows us to easily replace Ant Design in the future without changing all imports.
 * It preserves all Ant Design Input functionality and sub-components.
 *
 * @component
 * @example
 * import { Input } from '../GeneralComponents/ui';
 *
 * // Basic Input
 * <Input placeholder="Basic input" />
 *
 * // Input with sub-components
 * <Input.Group>
 *   <Input style={{ width: '20%' }} defaultValue="0571" />
 *   <Input style={{ width: '30%' }} defaultValue="26888888" />
 * </Input.Group>
 *
 * <Input.Search placeholder="Search" onSearch={onSearch} />
 * <Input.TextArea rows={4} placeholder="Textarea" />
 * <Input.Password placeholder="Password" />
 *
 * @see https://ant.design/components/input/ - Ant Design Input documentation
 */
const Input = (props) => {
  const ref = useRef(null);

  useEffect(() => {
    if (props.autoFocus === true) {
      const interval = setInterval(() => {
        if (ref.current) {
          ref.current.focus();
          clearInterval(interval);
        }
      }, 100);
    }
  }, []);

  return <AntInput {...props} ref={ref} />;
};

// Preserve Input sub-components
Input.Group = AntInput.Group;
Input.Search = AntInput.Search;
Input.TextArea = AntInput.TextArea;
Input.Password = AntInput.Password;

export default Input;
